      <div class="card-header transparent  text-muted">
        <div class="d-flex justify-content-between align-items-center mb-2">
    <div class = "fw-bolder fs-5">
  <label class="me-2">Client Name :</label>
  <span >{{Referral.lastName}}, {{Referral.firstName}} {{Referral.middleName}}</span>
</div>
  </div>
        <div class="align-items-center justify-content-between d-flex">
       
              <h4 class="mb-0 font-header">Notes</h4>
                      <div class="col text-end">
            <button type="button" class="btn blue-btn btn-sm butstyle" 
            (click)="printData()">
              <i class="fa fa-print"> </i>Print
            </button>
         
            <button type="button" class="btn blue-btn btn-sm butstyle m-2" data-bs-target="#addnotesmodalopen"
              data-bs-toggle="modal" (click)="opennewnote()" [disabled]="global.referralTab"   *ngIf="fp.referralnotescreate">Add Notes
            </button>
        
            <button type="button" class="btn blue-btn btn-sm butstyle" data-bs-target="#typelstmodalforagency" (click)="getStatusAll();" id="addtypelist"
            data-bs-toggle="modal" [disabled]="global.referralTab">Type List
            </button>
          </div>
        </div>
        <div class="row col-12 mt-5">
          <div class="col-3">
            <div class="row">
              <div class="col-4">
                <label>Start Date
                </label>
              </div>
              <div class="col">
                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"

                [selDate]="FromDateFilter"

                (inputFieldChanged)="DateFormat($event,'inputchanged','FilterFromDate')"

                (dateChanged)="DateFormat($event,'datechanged','FilterFromDate')">

            </my-date-picker>

              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-3">
                <label>End Date</label>
              </div>
              <div class="col">
                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"

                [selDate]="EndDateFilter"

                (inputFieldChanged)="DateFormat($event,'inputchanged','FilterToDate')"

                (dateChanged)="DateFormat($event,'datechanged','FilterToDate')">

            </my-date-picker>

              </div>
            </div>

          </div>


          <div class="col-3">
            <div class="row">
              <div class="col-2">
                <label>Type</label>
              </div>
              <div class="col">
                <ng-select class="width25"  [(ngModel)]="getclientnotes.typeListId"
                 [items]="typedropdown" bindLabel="Value" bindValue="Key"  [disabled]="global.referralTab">
                </ng-select>
              </div>
            </div>

          </div>
          <div class="col text-end ">
            <div>
                <button type="button" class="btn blue-btn btn-sm butstyle ml-1"  [disabled]="global.referralTab"
                 (click)="ApplyFilter()">Apply
                </button>
                <button type="button" class="btn blue-btn btn-sm butstyle ml-1"  [disabled]="global.referralTab" 
                (click)="RefreshFilter()"
                style="margin-left: 11px;">Refresh
            </button>
            </div>
        </div>
        </div>
        <!-- .....................................Addnotes grid......................................................... -->

       <div class="row mb-2 mt-2">
          <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
              <div class="card-body  widget-body pt-2">
               

                <ejs-grid #gridnotes id="gridnotes" [dataSource]='datanotes |async' [allowResizing]='true' [allowFiltering]='true'
                  [pageSettings]='initialPage' [filterSettings]='filterOptions' [showColumnChooser]='true' allowTextWrap='true'
                  [allowSorting]='true' allowPaging='true' (actionBegin)="onActionCompletenotes($event)"
                  (dataStateChange)='dataStateChangenotes($event)'>
                  <e-columns>
                    <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                      [showInColumnChooser]='false'>
                      <ng-template #template let-data>
                        <button class="btn btn-edit-table me-2"  [disabled]="global.referralTab" data-bs-target="#addnotesmodalopen" data-bs-toggle="modal"
                          (click)="editNote(data)"  *ngIf="fp.referralnotesupdate"><i class="fa fa-edit"></i></button>

                        <button class="btn btn-delete-table "   [disabled]="global.referralTab" data-bs-target="#deletemodalnotes"
                          (click)="noteDeleteId(data.id)" data-bs-toggle="modal"  *ngIf="fp.referralnotesdelete"><i class="fa fa-trash"></i></button>
                      </ng-template>

                    </e-column>
                    <e-column minWidth=100 field="date" headerText="Date" type="date"  [format]="formatOptions">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="initial" headerText="Initials" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="notes" headerText="Client Notes" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="typeListName" headerText="Type" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>

                    <!--------------------------------table header icon---------------->
                    <e-column width="50" [showInColumnChooser]='false'>
                      <ng-template #headerTemplate let-data>
                        <div>
                          <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                            </i></span>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
          </div>
        </div>

      </div>
   
  <!-- ............................................ADDNOTES MODAL.......................................................................... -->


  <span id="Addnotes" data-bs-target="#addnotesmodalopen" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="addnotesmodalopen" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog   modal-lg-down" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel"
            *ngIf="addnoteBO.id=='00000000-0000-0000-0000-000000000000'"> Add Notes</h5>
          <h5 class="modal-title font-header" id="exampleModalLabel"
            *ngIf="addnoteBO.id!='00000000-0000-0000-0000-000000000000'">Update Notes</h5>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div class="modal-body">

          <div class="row">
            <div class="col-lg-5">
              <label>Date<sup class="super-script">*</sup>
              </label>
            </div>
            <div class="col-lg-7">
              <input type="datetime-local" class="form-control w-100" [(ngModel)]="addnoteBO.date" />
            </div>
          </div>

          <div class="row">
            <div class="col-lg-5">
              <label>Initials<sup class="super-script">*</sup>
              </label>
            </div>
            <div class="col-lg-7 mt-1">
              <input type="text" class="form-control w-100" [(ngModel)]="addnoteBO.initial" disabled="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-5">
              <label>Notes<sup class="super-script">*</sup>
              </label>
            </div>
            <div class="col-lg-7 mt-1">
              <textarea class="form-control w-100" rows="5" cols="50" [(ngModel)]="addnoteBO.notes"></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-5">
              <label>Type<sup class="super-script">*</sup>
              </label>
            </div>
            <div class="col-lg-7 mt-1">
             
              <ng-select *ngIf="addnoteBO.id!='00000000-0000-0000-0000-000000000000'" 
                   [(ngModel)]="addnoteBO.typeListId" [items]="typedropdown" 
                   bindLabel="Value" id="typeNamedrop"
                   bindValue="Key">
                </ng-select>
                
                <ng-select *ngIf="addnoteBO.id=='00000000-0000-0000-0000-000000000000'" [multiple]="true" 
  [(ngModel)]="addnoteBO.typeListIds" [items]="typedropdown" id="typelistdropdown"
  bindLabel="Value" bindValue="Key" [disabled]="addnoteBO.notes==''
  ||addnoteBO.notes==null ">
  </ng-select>

           

            </div>
          </div>

        </div>

        <div class="modal-footer mt-4">
          <button class="btn btn-sm btn-primary" type="button" 
            [disabled]="
              (addnoteBO.typeListIds == undefined || addnoteBO.typeListIds.length == 0) ||
              (addnoteBO.notes == '' || addnoteBO.notes == null || addnoteBO.notes == undefined) || isNotesDisable" 
            (click)="saveNote(addnoteBO)" id="saveclosenotes"
            *ngIf="addnoteBO.id=='00000000-0000-0000-0000-000000000000'">
            Save & Close
          </button>
        
          <button class="btn btn-sm btn-primary" type="button" 
            [disabled]="
              (addnoteBO.typeListId == undefined || addnoteBO.typeListId == null) ||
              (addnoteBO.notes == '' || addnoteBO.notes == null || addnoteBO.notes == undefined) || isNotesDisable" 
            (click)="saveNote(addnoteBO)" id="saveupdatenotes"
            *ngIf="addnoteBO.id!='00000000-0000-0000-0000-000000000000'">
            Update & Close
          </button>
        
          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="notespopclose">
            Close
          </button>
        </div>        
        
      </div>
    </div>
  </div>
  
  <!--------------------------Type List-------------------------------------------------------->
<span id="typeforagencyopen" data-bs-toggle="modal" data-bs-target="#typelstmodalforagency"></span>
<div class="modal hide fade modalbackgrod" id="typelstmodalforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog">

    <div class="modal-content">
      <div class="modal-header">
        <div class="row col-12">
          <div class="col-2">
            <h5 class="mb-0 font-header" id="exampleModalLabel">Type</h5>
          </div>
        
          
          <div class="col-5 d-flex">
            <span class="col-4">Show Type&nbsp;</span>

            <!-- Dropdown -->
            <ng-select 
              class="col select-dropdown" 
              [(ngModel)]="getClient.statusLid" 
              (ngModelChange)="gettypegrid()"
              [clearable]="false"
              [searchable]="true" 
              [items]="statusListAll" 
              bindLabel="lovName" 
              bindValue="id">
            </ng-select>
            </div>
            <div class="col-4 text-center">
            <!-- Add Type Button -->
            <button 
            (click)="opennewnote(); addnewtype();" 
            id="addtype"
            class="btn blue-btn btn-sm" 
            data-bs-toggle="modal" 
            data-bs-target="#addtypeforagency">
            Add Type
        </button>
        </div>
    
        <!-- Close Button with some gap on the right -->
        <button 
            type="button" 
            class="btn-close ms-3" 
            data-bs-dismiss="modal" 
            aria-label="Close">
        </button>
          
        
        </div>


      </div>
      <div class="modal-body ">
        <ejs-grid #grid [dataSource]='typelst' [allowResizing]='true' [allowSorting]='true'
        [filterSettings]='filterOptions1'>
          <e-columns>
            <e-column minWidth=100 headerText="Actions">
              <ng-template #template let-data>
                <button class="btn btn-edit-table " data-bs-target="#addtypeforagency" data-bs-toggle="modal" id="edittype"
                  (click)="addtypeBO=data"><i class="fa fa-edit"></i></button>&nbsp;
                  <button class="btn btn-delete-table  ml-1" data-bs-toggle="modal"
                          (click)="setDeleteId(data.id)" data-bs-target="#deletemodal"><i
                              class="fa fa-trash"></i></button>

              </ng-template>
            </e-column>
            <e-column minWidth=100 field="statusLovName" headerText="Status" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="typeNumber" headerText="Number" type="number"></e-column>
            <e-column minWidth=100 field="typeName" headerText="Type Name">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>


          </e-columns>
        </ejs-grid>
        <div *ngIf="TypeNotesDataList.length == 0" class="text-center" style="color:red">
          <p>No data available</p>
        </div>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="edittypeclose">Close</button>
      </div>
    </div>

  </div>
</div>
<!------------------------Add Update Type-->
<span id="addtypeforagencyopen" data-bs-toggle="modal" data-bs-target="#addtypeforagency"></span>
<div class="modal hide fade modalbackgrod" id="addtypeforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog ">

    <div class="modal-content">
      <div class="modal-header">

        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="addtypeBO.id=='00000000-0000-0000-0000-000000000000'"> Add Type</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="addtypeBO.id!='00000000-0000-0000-0000-000000000000'">Update Type</h5>
        <button type="button" class="btn-close mt-0" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col-lg-3">
            <label>Status
            </label>
          </div>
          <div class="col-lg-9">
            <ng-select [items]="StatusList" class="width25" [searchable]="true" [clearable]="false"
              bindLabel="lovName" bindValue="id" [(ngModel)]="addtypeBO.statusLid" >
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Number</label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="addtypeBO.typeNumber" [disabled]="true" id="Number" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Type Name</label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="addtypeBO.typeName" id="TypeName" />
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-primary" type="button" 
        [disabled]="!addtypeBO.typeName || addtypeBO.typeName.trim() === '' || addtypeBO.typeNumber == null || addtypeBO.typeNumber === ''" 
        (click)="saveupdatetype(addtypeBO)" id="savetypenotes" 
        *ngIf="addtypeBO.id == '00000000-0000-0000-0000-000000000000'">
        Save & Close
      </button>
    
      <!-- Update & Close Button -->
      <button class="btn btn-sm btn-primary" type="button" 
        [disabled]="!addtypeBO.typeName || addtypeBO.typeName.trim() === '' || addtypeBO.typeNumber == null || addtypeBO.typeNumber === ''" 
        (click)="saveupdatetype(addtypeBO)" id="updatetypenotes" 
        *ngIf="addtypeBO.id != '00000000-0000-0000-0000-000000000000'">
        Update & Close
      </button>
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="closetypenotes">Close</button>
      </div>
    </div>

  </div>
</div>

  <!-- ..........................type deletemodal................................... -->

  <span id="openModaltype" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ..........................notes deletemodal................................... -->

  <span id="openModal2" data-bs-target="#deletemodalnotes" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodalnotes" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"(click)="NoteDelete()">Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>


  <!-- ........................................close without save............................................ -->

  <span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
  <div class="modal fade primarymodal modalbackgrod" id="CloseModal" tabindex="-1" role="dialog"
   aria-labelledby="exampleModalLabel" aria-hidden="true" >
      <div class="modal-dialog create-update-zip" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title font-header" id="exampleModalLabel" >Close</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                  </button>
              </div>
              <div class="modal-body">
                You want to close without save?
              </div>
              <div class="modal-footer">
              <button type="button" class="btn blue-btn btn-sm">Yes</button>
              <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
              </div>
          </div>
      </div>
  </div>



  <div style="position: absolute; left: -1000px; top: 500px;" *ngIf="noteLst!=null">
    <kendo-pdf-export #pdfNotesList paperSize="A4">
      <div style="width: 700px;">
        <div class="row mb-2">
          <div class="col pl-0">
            <div widget class="card border-0 box-shadow ">
              <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div>
                  <div class="row">
                    <div class="col-lg-10">
                      <h4 style="color:#004290">
                        Referral Notes </h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <hr style="margin-top: 0rem" />
                      <div><label class="font-weight ">Referral Name:</label>{{Referral.lastName}}, {{Referral.firstName}} {{Referral.middleName}} </div>

                      <div> <label class="font-weight ">DOB:</label>
                        {{Referral.dOB| date:'MM/dd/yyyy'}}
                      </div>
                    </div>
                  </div>
                  <hr>
                  <ng-container *ngFor="let items of noteLst">
                    <div> <label class="font-weight ">Date:</label>
                      {{items.date | date:'MM/dd/yyyy'}}
                    </div>
                    <div> <label class="font-weight ">Initial:</label>
                      {{items.initial}}
                    </div>
                    <div> <label class="font-weight ">Type:</label>
                      {{items.typeListName}}
                    </div>
                    <div class="row  ">
                      <div class="col-lg-12 ">
                        <label style=" text-align: justify;width: 600px;"
                          class="font-weight ">Notes:&nbsp;{{items.notes}}</label>
                      </div>
                    </div>
                    <hr>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </kendo-pdf-export>
  </div>